/**
 * Paginação: "N–M de TOTAL" com os controles ‹ ›. Trabalha em páginas base 0 e
 * traduz para o intervalo humano (1-based) na exibição. Some quando há uma página
 * só — um controle de navegação que não navega para lugar nenhum é ruído.
 */
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function Paginacao({
  pagina,
  porPagina,
  total,
  onMudar,
}: {
  pagina: number; // base 0
  porPagina: number;
  total: number;
  onMudar: (pagina: number) => void;
}) {
  const ultima = Math.max(0, Math.ceil(total / porPagina) - 1);
  if (total === 0) return null;

  const primeiro = pagina * porPagina + 1;
  const ultimo = Math.min((pagina + 1) * porPagina, total);

  return (
    <div className="flex items-center justify-between gap-4 border-t border-border px-4 py-3">
      <span className="tipo-dado text-text-tertiary">
        {primeiro}–{ultimo} de {total}
      </span>
      {ultima > 0 && (
        <div className="flex items-center gap-1">
          <Button
            variant="secundario"
            size="sm"
            disabled={pagina <= 0}
            onClick={() => onMudar(pagina - 1)}
            aria-label="Página anterior"
          >
            <ChevronLeft />
          </Button>
          <span className="tipo-dado px-2 text-text-secondary">
            {pagina + 1} / {ultima + 1}
          </span>
          <Button
            variant="secundario"
            size="sm"
            disabled={pagina >= ultima}
            onClick={() => onMudar(pagina + 1)}
            aria-label="Próxima página"
          >
            <ChevronRight />
          </Button>
        </div>
      )}
    </div>
  );
}
